import type {SVGProps} from 'react'
import * as React from 'react'
const NoDataIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="121" height="120" fill="none" viewBox="0 0 121 120" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M120.5 100.69C120.5 84.4069 93.6371 71.207 60.5 71.207C27.3629 71.207 0.5 84.4069 0.5 100.69C0.5 116.973 120.5 116.973 120.5 100.69Z"
      fill="url(#paint0_linear_17513_7084)"
    />
    <g opacity="0.8">
      <g opacity="0.8">
        <path opacity="0.8" d="M15.5 83.3191V89.7846" stroke="#D9DADD" strokeWidth="2.66667" strokeLinecap="round" />
        <path
          opacity="0.8"
          d="M15.3268 70.345C11.4058 74.4614 9.7149 77.5919 10.254 79.7367C11.0626 82.9539 14.2807 83.4484 15.0761 83.4484C15.8715 83.4484 20.5011 83.5095 20.5011 79.2214C20.5011 76.3627 18.7763 73.4039 15.3268 70.345Z"
          fill="#D9DADD"
        />
      </g>
      <g opacity="0.8">
        <path opacity="0.8" d="M101.707 81.8752V86.4011" stroke="#D9DADD" strokeWidth="2.66667" strokeLinecap="round" />
        <path
          opacity="0.8"
          d="M101.705 72.7588C98.9606 75.6836 97.777 77.9079 98.1544 79.4319C98.7204 81.7177 100.973 82.0691 101.53 82.0691C102.087 82.0691 105.327 82.1125 105.327 79.0657C105.327 77.0346 104.12 74.9322 101.705 72.7588Z"
          fill="#D9DADD"
        />
      </g>
      <g opacity="0.8">
        <path opacity="0.8" d="M112.742 88.0496V91.6056" stroke="#D9DADD" strokeWidth="2.66667" strokeLinecap="round" />
        <path
          opacity="0.8"
          d="M112.914 81.3794C110.823 83.5459 109.921 85.1936 110.208 86.3224C110.64 88.0157 112.356 88.276 112.78 88.276C113.204 88.276 115.673 88.3081 115.673 86.0512C115.673 84.5466 114.754 82.9894 112.914 81.3794Z"
          fill="#D9DADD"
        />
      </g>
    </g>
    <g filter="url(#filter0_f_17513_7084)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.8125 79.1205L40.5299 72.7585L59.4773 84.8275H52.1941L29.8125 79.1205Z"
        fill="url(#paint1_linear_17513_7084)"
      />
    </g>
    <path
      d="M56.8807 36.8963C57.1929 36.8963 57.446 37.1476 57.446 37.4577V58.7889C57.446 59.7184 58.2059 60.4729 59.1421 60.4729H80.6256C80.7756 60.4729 80.9194 60.532 81.0254 60.6373C81.1314 60.7426 81.191 60.8854 81.191 61.0342C81.191 74.3651 70.3068 85.1722 56.8807 85.1722C43.4546 85.1722 32.5703 74.3651 32.5703 61.0342C32.5703 47.7034 43.4546 36.8963 56.8807 36.8963ZM65.0799 34.1377C70.1759 34.1377 75.0632 36.1621 78.6666 39.7655C82.2701 43.3689 84.2945 48.2562 84.2945 53.3523C84.2945 53.652 84.1754 53.9395 83.9634 54.1515C83.7514 54.3634 83.464 54.4825 83.1642 54.4825H65.0799C64.7801 54.4825 64.4926 54.3634 64.2807 54.1515C64.0687 53.9395 63.9496 53.652 63.9496 53.3523V35.268C63.9496 34.9682 64.0687 34.6807 64.2807 34.4687C64.4926 34.2568 64.7801 34.1377 65.0799 34.1377Z"
      fill="url(#paint2_linear_17513_7084)"
    />
    <path
      d="M58.9406 36.9151C59.2527 36.9151 59.5057 37.1663 59.5057 37.4762V58.7991C59.5057 59.7283 60.2652 60.4825 61.201 60.4825H82.6754C82.8252 60.4825 82.969 60.5416 83.075 60.6469C83.1809 60.7521 83.2405 60.8948 83.2405 61.0436C83.2405 74.3693 72.3609 85.1722 58.9406 85.1722C45.5202 85.1722 34.6406 74.3693 34.6406 61.0436C34.6406 47.7179 45.5202 36.9151 58.9406 36.9151ZM67.0212 34.1377C72.1515 34.1377 77.0716 36.1759 80.6992 39.8038C84.3268 43.4317 86.3648 48.3523 86.3648 53.483C86.3648 53.7848 86.2449 54.0742 86.0315 54.2876C85.8181 54.501 85.5287 54.6209 85.2269 54.6209H67.0212C66.7195 54.6209 66.43 54.501 66.2167 54.2876C66.0033 54.0742 65.8834 53.7848 65.8834 53.483V35.2757C65.8834 34.9738 66.0033 34.6844 66.2167 34.471C66.43 34.2576 66.7195 34.1377 67.0212 34.1377Z"
      fill="url(#paint3_linear_17513_7084)"
    />
    <defs>
      <filter
        id="filter0_f_17513_7084"
        x="28.4792"
        y="71.4252"
        width="32.3307"
        height="14.7355"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="0.666667" result="effect1_foregroundBlur_17513_7084" />
      </filter>
      <linearGradient
        id="paint0_linear_17513_7084"
        x1="60.5"
        y1="71.207"
        x2="60.5"
        y2="109.62"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D9DADD" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_17513_7084"
        x1="49.8556"
        y1="78.4731"
        x2="50.2213"
        y2="79.789"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D9DADD" stopOpacity="0" />
        <stop offset="1" stopColor="#D9DADD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_17513_7084"
        x1="58.4324"
        y1="85.1722"
        x2="58.4324"
        y2="34.1377"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CDCED2" />
        <stop offset="1" stopColor="#F0F0F0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_17513_7084"
        x1="60.5027"
        y1="80.6668"
        x2="60.5027"
        y2="38.3043"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D9DADD" />
        <stop offset="1" stopColor="#F1F1F1" />
      </linearGradient>
    </defs>
  </svg>
)
export default NoDataIcon
